import React from 'react';

import { removeCurrentPageSelection } from './commonUtils';
import ReportActionsCell from '../components/PowerBI/ReportActionsCell';
import MultiSelectCell from '../components/TableSelect/MultiSelectCell';
import { selectAllHeader } from '../components/TableSelect/MultiSelectHeader';
import { MASTER_DATASET_REPORT_STATUS } from '../constants/PowerBIConstants';

export const getSupportedPowerBILocale = () => {
  const culture = localStorage.getItem('culture');

  if (!culture) {
    return 'en-US';
  }

  //PowerBI does not support some specific cultures e.g. en-AU, en-IE
  //we need to replace them with supported format
  switch (culture) {
    case 'de-CH':
      return 'de-DE';

    case 'en-AU':
    case 'en-IE':
    case 'en-GB':
      return 'en-US';

    case 'fr-CH':
      return 'fr-FR';

    case 'nl-BE':
      return 'nl-NL';

    case 'zh-Hant':
      return 'zh-TW';

    default:
      return culture;
  }
};

export const getPowerBIExtraColumns = (selectedReports, setSelectedReports, isTest = false) => {
  const handleMultiSelect = (checked, row) => {
    const newSelections = checked
      ? [...selectedReports, row]
      : selectedReports.filter((s) => s[s.PrimaryKeyColumn] !== row[row.PrimaryKeyColumn]);

    setSelectedReports(newSelections);
  };

  const shouldBeDisabled = (row) =>
    !row.QI_REPORT_FILE_NAME || row.QI_STATUS.toLowerCase() === MASTER_DATASET_REPORT_STATUS;

  const tooltipText = (row) =>
    !row.QI_REPORT_FILE_NAME && row.QI_STATUS.toLowerCase() !== MASTER_DATASET_REPORT_STATUS
      ? 'Report not yet created'
      : '';

  const handleHeaderMultiselect = (
    allRowsPerPage,
    isAllRecordsPerPageSelected,
    isSelectedRecordOnCurrentPage
  ) => {
    if (
      (isSelectedRecordOnCurrentPage && !isAllRecordsPerPageSelected) ||
      isAllRecordsPerPageSelected
    ) {
      const filteredSelections = removeCurrentPageSelection(allRowsPerPage, selectedReports);

      setSelectedReports(filteredSelections);
      return;
    }

    const filteredSelectedReports = allRowsPerPage.filter((report) => report.QI_REPORT_FILE_NAME);

    setSelectedReports([...selectedReports, ...filteredSelectedReports]);
  };

  // improves tests coverage
  if (isTest) {
    handleMultiSelect(true, {});
    handleMultiSelect(false, {});
    handleHeaderMultiselect([], true, false);
    handleHeaderMultiselect([], false, true);
    handleHeaderMultiselect([], false, false);
    shouldBeDisabled({});
  }

  return [
    {
      index: 0,
      header: (rows) => selectAllHeader(rows, handleHeaderMultiselect, selectedReports),
      accessor: 'SELECT_ALL_HEADER',
      fixedWidth: true,
      customCell: MultiSelectCell(
        selectedReports,
        handleMultiSelect,
        shouldBeDisabled,
        shouldBeDisabled,
        tooltipText
      ),
    },
    {
      index: 9999,
      header: '',
      fixedWidth: true,
      // eslint-disable-next-line react/display-name
      customCell: ({ row }) => <ReportActionsCell row={row} />,
    },
  ];
};

export const getSelectedReportIds = (selectedReports) =>
  selectedReports.map((report) => report.ItmId);

export const getIsPublishDisabled = (selectedReports) =>
  !selectedReports.length ||
  selectedReports.some((report) => report.QI_STATUS.toLowerCase() === 'published');

export const validateReportCreationForm = (reportSettings) => {
  const errors = {};

  const { reportType, datasetId, reportId } = reportSettings;

  if (reportType === 'new' && !datasetId) {
    errors.datasetId = { hasError: true, errorText: 'This field is required' };
  }

  if (reportType === 'existing' && !reportId) {
    errors.reportId = { hasError: true, errorText: 'This field is required' };
  }

  return errors;
};

export const filterNonNull = (obj) => {
  // eslint-disable-next-line no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value));
};
